module.exports = __webpack_public_path__ + "static/media/hz4.aeb6f409.png";